import { createStore } from '@@/react-store';

const store = createStore();

export const createModel = store.createModel;

export const StoreProvider = store.Provider;
